import { SessionResource } from '@clerk/types'
import { authExchange } from '@urql/exchange-auth'

import { intervalWhile } from 'lib/utils/interval'

let token: string | null | undefined = null

export const resetToken = () => {
  token = null
}

const urqlAuth = authExchange(async utils => {
  // Hold urql operation until Clerk Session is ready
  // If not, the operation (request) could be triggered without the jwt token
  const session = await intervalWhile<SessionResource | undefined>(
    () => typeof window !== 'undefined' && !!window.Clerk?.session,
    () => window.Clerk?.session,
    100,
  )

  const getToken = () => session?.getToken?.()?.catch(() => null) // handle 401 error

  token = await getToken()

  return {
    addAuthToOperation: operation => {
      if (typeof window !== 'undefined' && !window.Clerk?.session)
        return operation

      if (!token) return operation

      return utils.appendHeaders(operation, {
        Authorization: `Bearer ${token}`,
      })
    },
    willAuthError: () => {
      // Break the loop if there is no session anymore.
      if (typeof window !== 'undefined' && !window.Clerk?.session) {
        return false
      }

      if (!token) return true

      const base64Url = token.split('.')[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      const payload = JSON.parse(atob(base64))
      const expiration = payload.exp

      if (!expiration) {
        return true
      }

      const currentTimestamp = Math.floor(Date.now() / 1000)

      return expiration < currentTimestamp
    },
    didAuthError: () => {
      // Break the loop if there is no session anymore.
      if (typeof window !== 'undefined' && !window.Clerk?.session) {
        return false
      }

      return !token
    },
    refreshAuth: async () => {
      token = await getToken()
    },
  }
})

export default urqlAuth
